import Tabs from './tabs'

export const initTabs = function() {
  [...document.querySelectorAll('.js-tabs')].map(function(tabs, index) {
    (new Tabs(tabs)).init();
  });
}
